var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfilePlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0C11.6421 0 15 3.35786 15 7.5C15 11.6421 11.6421 15 7.5 15C3.35786 15 0 11.6421 0 7.5C0 3.35786 3.35786 0 7.5 0ZM7.5 2.58398C7.08579 2.58398 6.75 2.91977 6.75 3.33398V6.75H3.33398C2.91977 6.75 2.58398 7.08579 2.58398 7.5C2.58398 7.91421 2.91977 8.25 3.33398 8.25H6.75V11.667C6.75018 12.0811 7.0859 12.417 7.5 12.417C7.9141 12.417 8.24982 12.0811 8.25 11.667V8.25H11.667C12.0812 8.25 12.417 7.91421 12.417 7.5C12.417 7.08579 12.0812 6.75 11.667 6.75H8.25V3.33398C8.25 2.91977 7.91421 2.58398 7.5 2.58398Z",
    fill: "#9061DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePlus);
export default __webpack_public_path__ + "static/media/ProfilePlus.5179eee61707bfe8bf2ab17697b278f9.svg";
export { ForwardRef as ReactComponent };